module.exports = __webpack_public_path__ + "media/customize/banner-top-right-16210d18.svg";